<template>
    <el-dialog title="Upload Video"
               :visible.sync="showDialog"
               append-to-body
               :close-on-click-modal="false">

        <el-form :model="formData" label-position="top">
            <div v-loading="isBusy">
                <el-form-item label="Scope of Ad" prop="videoType" :required="true">
                    <el-radio-group v-model="formData.videoType">
                        <el-radio label="employer" border>Employer</el-radio>
                        <el-radio label="job" border>Job</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="Select job" prop="jobId" :required="formData.videoType === 'job'">
                    <el-select v-model="formData.jobId" placeholder="Select job that will be assigned to the ad"
                               :disabled="formData.videoType !== 'job'" style="width:100%">
                        <el-option v-for="job in employerJobs"
                                   :key="`job-${job.id}`"
                                   :label="`${job.id} - ${job.name}` + (!job.admin_description ? '' : ` (${job.admin_description})`)"
                                   :value="job.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-row>
                    <el-col :span="24">Select video files (one or more)</el-col>
                </el-row>
                <el-row :gutter="10" style="padding: 10px 0 30px">
                    <el-col :xs="24" :lg="8">
                        <el-row>
                            <el-col :span="24" class="text-center">
                                <el-form-item>
                                    <el-upload
                                        ref="uploadVideo"
                                        action=""
                                        :http-request="file => addVideo(file, `Portrait`)"
                                        :file-list="formData.filePortrait">
                                        <el-button slot="trigger" size="small" type="primary">Select 9:16 Video</el-button>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="video-preview-wrapper" style="width:20%">
                                    <div class="video-preview-body" style="aspect-ratio:9/16">
                                        <i class="fas fa-ellipsis-v video-preview-3dots"></i>
                                        <i class="far fa-play-circle video-preview-play"></i>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :xs="24" :lg="8">
                        <el-row>
                            <el-col :span="24" class="text-center">
                                <el-form-item>
                                    <el-upload
                                        ref="uploadVideo"
                                        action=""
                                        :http-request="file => addVideo(file, `Landscape`)"
                                        :file-list="formData.fileLandscape">
                                        <el-button slot="trigger" size="small" type="primary">Select 16:9 Video</el-button>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="video-preview-wrapper" style="width:35%">
                                    <div class="video-preview-body" style="aspect-ratio:16/9">
                                        <i class="fas fa-ellipsis-v video-preview-3dots"></i>
                                        <i class="far fa-play-circle video-preview-play"></i>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :xs="24" :lg="8">
                        <el-row>
                            <el-col :span="24" class="text-center">
                                <el-form-item>
                                    <el-upload
                                        ref="uploadVideo"
                                        action=""
                                        :http-request="file => addVideo(file, `Square`)"
                                        :file-list="formData.fileSquare">
                                        <el-button slot="trigger" size="small" type="primary">Select 1:1 Video</el-button>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="video-preview-wrapper" style="width:20%">
                                    <div class="video-preview-body" style="aspect-ratio:1/1">
                                        <i class="fas fa-ellipsis-v video-preview-3dots"></i>
                                        <i class="far fa-play-circle video-preview-play"></i>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>

                <el-form-item>
                    <el-button @click="resetFormWithEmit" class="pull-right">Cancel</el-button>
                    <el-button type="primary" @click="uploadVideo" class="pull-right" style="margin-right:5px">Upload video</el-button>
                </el-form-item>
            </div>

            <div style="margin: 10px 0;">
                <el-form-item v-if="uploadProgress.isVisible">
                    <el-progress
                        :text-inside="true"
                        :stroke-width="18"
                        :percentage="uploadProgress.percentage"
                        :format="uploadProgressBarText"
                        :status="uploadProgress.status"></el-progress>
                </el-form-item>
            </div>
        </el-form>

    </el-dialog>
</template>

<script>
export default {
    props: [
        'employerId',
        'isVisible'
    ],
    data() {
        return {
            isBusy: false,
            formData: {
                videoType: 'employer',
                jobId: null,
                fileSquare: [],
                fileLandscape: [],
                filePortrait: [],
            },
            employerJobs: [],
            uploadProgress: {
                percentage: 0,
                isVisible: false,
                status: '',
            }
        };
    },
    watch: {
        'formData.videoType'(newValue) {
            if (newValue === 'job' && this.employerJobs.length === 0) {
                this.loadJobs();
            }
        }
    },
    computed: {
        showDialog: {
            get() {
                return this.isVisible;
            },
            set(val) {
                this.$emit('close')
            }
        }
    },
    methods: {
        uploadProgressBarText() {
            if (this.uploadProgress.status === 'exception') return 'Failed!';
            else if (this.uploadProgress.status === 'success') return 'Done!';
            else if (this.uploadProgress.percentage <= 0) return 'Preparing file ...';
            else if (this.uploadProgress.percentage >= 100) return 'Processing file ...';
            else return `${this.uploadProgress.percentage}%`;
        },
        loadJobs() {
            this.isBusy = true;
            return axios.get(url(`admin/employer/${this.employerId}/jobs/dropdown`))
                .then(response => {
                    this.employerJobs = response.data;
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },
        addVideo(file, type) {
            this.formData[`file${type}`] = [file.file];
        },
        resetForm() {
            this.formData.fileSquare = [];
            this.formData.filePortrait = [];
            this.formData.fileLandscape = [];
            this.formData.jobId = null;
            this.formData.videoType = 'employer';
        },
        resetFormWithEmit() {
            this.resetForm();
            this.$emit('close');
        },
        uploadVideo() {
            this.isBusy = true;
            this.uploadProgress.status = null;
            this.uploadProgress.isVisible = true;

            const onUploadProgress = (event) => {
                this.uploadProgress.percentage = Math.round((100 * event.loaded) / event.total);
            };

            const data = new FormData();

            // employer
            data.append('employer_id', this.employerId);

            // job
            if (this.formData.videoType === 'employer') data.append('job_id', null);
            else data.append('job_id', this.formData.jobId);

            // videos
            data.append('video_file_square', this.formData.fileSquare[0]);
            data.append('video_file_portrait', this.formData.filePortrait[0]);
            data.append('video_file_landscape', this.formData.fileLandscape[0]);


            return axios.post(url(`admin/employer/${this.employerId}/upload-video`), data, {
                headers: {"Content-Type": "multipart/form-data"},
                onUploadProgress
            })
                .then(response => {
                    this.uploadProgress.status = 'success';

                    this.resetForm();

                    setTimeout(() => {
                        this.uploadProgress.isVisible = false;
                        this.uploadProgress.percentage = 0;
                        this.$emit('uploaded');
                    }, 500);
                })
                .catch(err => {
                    this.uploadProgress.status = 'exception';
                    this.$message({
                        message: err.toString(),
                        type: 'error'
                    });
                    setTimeout(() => {
                        this.uploadProgress.isVisible = false;
                        this.uploadProgress.percentage = 0;
                    }, 3000);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        }
    }
}
</script>

<style scoped>
.video-preview-wrapper {
    padding: 0;
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.video-preview-body {
    background-color: #3756c0;
    border:2px solid #bfcbf3;
    border-radius: 5px;
    position: relative;
    color: #bfcbf3;
}

.video-preview-3dots {
    position: absolute;
    top: 4px;
    right: 4px;
    font-size: 10px;
}

.video-preview-play {
    font-size: 2.2rem;
    position: absolute;
    top: calc(50% - 1.1rem);
    left: calc(50% - 1.1rem);
}
</style>